document.addEventListener( 'DOMContentLoaded', () => {
	class TWITTER {
		static SELECTOR_CLASS_BLOCK = '.wp-block-jtf-jtf-twitter'
		static SELECTOR_CLASS_IMAGE = '.jtf__twitterblock--image'
		static SELECTOR_CLASS_HASHTAGS = '.jtf__twitterblock--hashtags'
		static SELECTOR_CLASS_LATEST = '.jtf__twitterblock--latest'
		static SELECTOR_CLASS_THEME_RANDOM = '.jtf__twitterblock--theme-random'
		static CLASS_NAME_THEME_PREFIX = 'jtf__twitterblock--theme'
		static CLASS_NAME_HASHTAG = 'jtf__twitterblock--hashtag'
		static CLASS_NAME_ICON_HANDLE = 'jtf__twitterblock--iconandhandle'
		static CLASS_NAME_HANDLE = 'jtf__twitterblock--handle'
		static CLASS_NAME_TWEET = 'jtf__twitterblock--tweet'
		static CLASS_NAME_TWEET_DATE = 'jtf__twitterblock--tweetdate'
		static ATTR_DATA_IMG = 'data-img'
		static ATTR_DATA_HASH = 'data-hash'
		static ATTR_DATA_HANDLE = 'data-handle'
		static ATTR_ARIA_LABEL = 'aria-label'
		static TIMEOUT_DELAY = 1000
		static THEME_RANDOM_MAX = 4
		static HASHTAG_LOOP_LIMIT = 6
		static DEFAULT_IMAGE_URL = 'https://covers.tandf.co.uk/covers/TANF_MR.jpg'
		static TWITTER_HASHTAG_URL = 'https://twitter.com/hashtag/'
		static TWITTER_PROFILE_URL = 'https://twitter.com/'
		static TWITTER_API_ENDPOINT = '/wp-json/jtf/v1/twitter/single?account='
		static MEDIA_API_ENDPOINT = '/wp-json/wp/v2/media/'
		static INTERSECTION_ROOT_MARGIN = '150px 0px 0px 0px'

		constructor( context ) {
			this.context = context
			this.init()
		}

		shuffle( array ) {
			let currentIndex = array.length

			while ( currentIndex !== 0 ) {
				const randomIndex = Math.floor( Math.random() * currentIndex )
				currentIndex -= 1

				const temporaryValue = array[ currentIndex ]
				array[ currentIndex ] = array[ randomIndex ]
				array[ randomIndex ] = temporaryValue
			}

			return array
		}

		getSuffix( date ) {
			if ( date > 3 && date < 21 ) {
				return 'th'
			}

			switch ( date % 10 ) {
				case 1: {
					return 'st'
				}
				case 2: {
					return 'nd'
				}
				case 3: {
					return 'rd'
				}
				default: {
					return 'th'
				}
			}
		}

		addUrl( text ) {
			return text.replace( /(\b(https?|ftp|file):\/\/[\-A-Z0-9+&@#\/%?=~_|!:,.;]*[\-A-Z09+&@#\/%=~_|])/img, '<a href="$1">$1</a>' )
		}

		async setImage() {
			const images = this.context.querySelectorAll( TWITTER.SELECTOR_CLASS_IMAGE )

			if ( images.length > 0 ) {
				for ( const img of images ) {
					const data = img.getAttribute( TWITTER.ATTR_DATA_IMG )

					if ( data && data !== '0' ) {
						let imageIds = data.split( ',' )
						imageIds = this.shuffle( imageIds )

						try {
							const response = await fetch( TWITTER.MEDIA_API_ENDPOINT + imageIds[ 0 ] )
							const json = await response.json()
							this.lazyLoadBgImage( img, json.media_details.sizes.medium.source_url )
						} catch ( error ) {
							this.lazyLoadBgImage( img, TWITTER.DEFAULT_IMAGE_URL )
						}
					} else {
						this.lazyLoadBgImage( img, TWITTER.DEFAULT_IMAGE_URL )
					}
				}
			}
		}

		lazyLoadBgImage( element, imageUrl ) {
			if ( imageUrl ) {
				const callback = ( entries ) => {
					entries.forEach( ( entry ) => {
						if ( entry.isIntersecting ) {
							element.style.backgroundImage = `url(${ imageUrl })`
						}
					} )
				}
				const options = {
					root: null,
					rootMargin: TWITTER.INTERSECTION_ROOT_MARGIN,
					threshold: 0,
				}
				const observer = new IntersectionObserver( callback, options )
				observer.observe( element )
			}
		}

		// noinspection FunctionWithMultipleLoopsJS
		init() {
			const themeRandomEl = this.context.querySelector( TWITTER.SELECTOR_CLASS_THEME_RANDOM )
			if ( themeRandomEl ) {
				const rand = Math.floor( Math.random() * TWITTER.THEME_RANDOM_MAX ) + 1
				this.context.classList.add( TWITTER.CLASS_NAME_THEME_PREFIX + rand )
			}

			const hashtagElements = this.context.querySelectorAll( TWITTER.SELECTOR_CLASS_HASHTAGS )
			hashtagElements.forEach( ( hashtagEl ) => {
				const data = hashtagEl.getAttribute( TWITTER.ATTR_DATA_HASH )

				if ( data ) {
					let hashtags = data.split( ',' )
					hashtags = this.shuffle( hashtags )

					hashtagEl.innerHTML = ''

					const loopLimit = hashtags.length <= 5 ? hashtags.length : TWITTER.HASHTAG_LOOP_LIMIT

					for ( let x = 0; x < loopLimit; x++ ) {
						const tagEle = document.createElement( 'a' )
						tagEle.className = TWITTER.CLASS_NAME_HASHTAG
						tagEle.href = TWITTER.TWITTER_HASHTAG_URL + hashtags[ x ].trim()
						tagEle.target = '_blank'
						tagEle.innerHTML = '#' + hashtags[ x ].trim()
						tagEle.setAttribute( TWITTER.ATTR_ARIA_LABEL, 'Open hashtag ' + hashtags[ x ].trim() + ' on Twitter' )
						hashtagEl.appendChild( tagEle )
					}
				}
			} )

			const latestEl = this.context.querySelector( TWITTER.SELECTOR_CLASS_LATEST )
			if ( latestEl ) {
				const handle = latestEl.getAttribute( TWITTER.ATTR_DATA_HANDLE )

				fetch( TWITTER.TWITTER_API_ENDPOINT + handle )
				.then( ( response ) => {
					return response.json()
				} )
				.then( ( json ) => {
					const monthNames = [ 'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December' ]

					const date = new Date( json[ 0 ][ 'created_at' ] )
					const dayNumber = date.getDate()
					const month = monthNames[ date.getMonth() ]

					const handleIconContainer = document.createElement( 'a' )
					handleIconContainer.className = TWITTER.CLASS_NAME_ICON_HANDLE

					const tweetHandle = document.createElement( 'a' )
					tweetHandle.className = TWITTER.CLASS_NAME_HANDLE
					tweetHandle.href = TWITTER.TWITTER_PROFILE_URL + handle

					const tweetBird = document.createElement( 'i' )
					tweetBird.className = 'fab fa-twitter'

					handleIconContainer.appendChild( tweetBird )
					handleIconContainer.appendChild( tweetHandle )

					tweetHandle.innerHTML = '@' + handle

					const tweetData = document.createElement( 'div' )
					tweetData.className = TWITTER.CLASS_NAME_TWEET

					const tweetDate = document.createElement( 'div' )
					tweetDate.className = TWITTER.CLASS_NAME_TWEET_DATE

					tweetDate.innerHTML = month + ' ' + dayNumber + this.getSuffix( dayNumber )
					tweetData.innerHTML = this.addUrl( json[ 0 ][ 'full_text' ] )
					latestEl.innerHTML = ''
					latestEl.appendChild( handleIconContainer )
					latestEl.appendChild( tweetData )
					latestEl.appendChild( tweetDate )

					const mediaItem = json?.[ 0 ]?.[ 'extended_entities' ]?.[ 'media' ]?.[ 0 ]?.[ 'media_url' ]

					if ( mediaItem ) {
						const imageEl = this.context.querySelector( TWITTER.SELECTOR_CLASS_IMAGE )
						if ( imageEl ) {
							imageEl.style.backgroundImage = `url(${ mediaItem })`
						}
					} else {
						this.setImage().then( () => {} )
					}
				} )
				.catch( () => {
					this.setImage().then( () => {} )
				} )
			} else {
				this.setImage().then( () => {} )
			}
		}
	}

	setTimeout( () => {
		const blocks = document.querySelectorAll( TWITTER.SELECTOR_CLASS_BLOCK )
		if ( blocks.length > 0 ) {
			blocks.forEach( ( block ) => {
				new TWITTER( block )
			} )
		}
	}, TWITTER.TIMEOUT_DELAY )
} )
